// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';

import Logo from '@portal/assets/svg/logos/home_logo.svg?react';

import PanelSidebarMenu from '../PanelSidebarMenu/PanelSidebarMenu';

import PanelSidebarProfile from '../PanelSidebarProfile/PanelSidebarProfile';
import PanelSidebarBottom from '../PanelSidebarBottom/PanelSidebarBottom';
import useReduxState from '@portal/hooks/useReduxState';

export interface PanelSideBarProps {
  routes: models.Route[];
  name: string;
  balance: string | null;
  rawBalance?: number | null;
  taxIdentifier: string;
  agency?: string | null;
  account?: string | null;
  bankCode?: string | null;
  bankAccount?: string | null;
  investmentProfile?: number | null;
  overdraft: string | null;
  rawOverdraft?: number | null;
}

const PanelSidebar = (props: PanelSideBarProps) => {
  const {
    theme: { currentTheme },
  } = useReduxState();
  const getInitialRoute = () =>
    props.routes.find((route) => route.id === 'HOME')?.route;

  return (
    <div
      className="panel-sidebar"
      style={{
        background: currentTheme.background,
      }}
    >
      <div {...{ testId: 'home_Logo' }} className="panel-sidebar__logo">
        <Link to={getInitialRoute() ?? '/'}>
          <Logo width={220} height={80} />
        </Link>
      </div>
      <PanelSidebarProfile {...props} />
      <div className="panel-sidebar__menu">
        <PanelSidebarMenu routes={props.routes} />
      </div>
      <PanelSidebarBottom />
    </div>
  );
};

export default PanelSidebar;
